// extracted by mini-css-extract-plugin
module.exports = {"header":"Page_header__1QopT","title":"Page_title__3ql7T","article":"Page_article__2Stwi"};